import { createSlice } from "@reduxjs/toolkit";
import { showToast } from "src/components/ToastProvider";
import ToastTypes from "src/enum/ToastTypes";
import { v4 as uuidv4 } from "uuid";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
  },
  reducers: {
    addToCart(state, action) {
      const { showToastMessage = true, ...product } = action.payload;
      

      if (!state.cartItems) {
        state.cartItems = [];
      }

      let existingProduct = state.cartItems.find(
        (item) => item.ID === product.ID && item.variantId === product.variantId && item.slotId === product.slotId
      );
      if ((product.variantId === 0 || !product.variantId) && (product.slotId === 0 || !product.slotId)) {
        existingProduct = state.cartItems.find(
          (item) => item.ID === product.ID && !item.variantId && !item.slotId
        );
      }

      if (existingProduct) {
        if (product.quantityCount)
          existingProduct.quantity = product.quantityCount;
        else existingProduct.quantity++;
        
        // Update variantName if provided
        if (product.variantName) {
          existingProduct.variantName = product.variantName;
        }
        
        if (showToastMessage) {
          showToast("Quantity updated in the cart", ToastTypes.SUCCESS);
        }
      } else {
        const newCartItem = {
          ...product,
          quantity: product.quantityCount || 1,
          price: product.price,
          cartItemId: uuidv4(),
          markedPrice: product.markedPrice,
          imagePath: product?.images?.[0]?.imagePath || "",
          slug: product.slug,
          id: product.id,
          ...(product.variantId && { variantId: product.variantId }),
          ...(product.slotId && { slotId: product.slotId }),
          ...(product.variantName && { variantName: product.variantName }),
        };
        
        
        state.cartItems.push(newCartItem);
        if (showToastMessage) {
          showToast("Product added to the cart", ToastTypes.SUCCESS);
        }
      }
    },
    deleteFromCart(state, action) {
      state.cartItems = state.cartItems.filter(
        (item) => item.cartItemId !== action.payload
      );
    },
    decreaseQuantity(state, action) {
      const product = action.payload;
      const existingProduct = state.cartItems.find(
        (item) => item.cartItemId === product.cartItemId
      );

      if (existingProduct) {
        if (existingProduct.quantity === 1) {
          state.cartItems = state.cartItems.filter(
            (item) => item.cartItemId !== product.cartItemId
          );
        } else {
          existingProduct.quantity -= 1;
        }
      }
    },
    increaseQuantity(state, action) {
      const product = action.payload;
      const existingProduct = state.cartItems.find(
        (item) => item.cartItemId === product.cartItemId
      );

      if (existingProduct) {
        existingProduct.quantity += 1;
      }
    },
    deleteAllFromCart(state) {
      state.cartItems = [];
    },
  },
});

export const {
  addToCart,
  deleteFromCart,
  decreaseQuantity,
  increaseQuantity,
  deleteAllFromCart,
} = cartSlice.actions;
export default cartSlice.reducer;
